export default "__VITE_ASSET__CpjXEbNa__"